module.exports = __webpack_public_path__ + "static/media/CS2 -- UserFlow__Prototype.3bcf8b77.mov";